import * as PropTypes from 'prop-types';
/**
 * @hidden
 */
export var GridColumn = function (_) { return null; };
/**
 * @hidden
 */
GridColumn.displayName = 'KendoReactGridColumn';
/**
 * @hidden
 */
GridColumn.defaultProps = {
    filterable: true,
    editable: true,
    sortable: true,
    resizable: true,
    reorderable: true,
    groupable: true
};
/**
 * @hidden
 */
GridColumn.propTypes = {
    field: PropTypes.string,
    title: PropTypes.string,
    editable: PropTypes.bool,
    sortable: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.shape({
            allowUnsort: PropTypes.bool
        })
    ]),
    cell: PropTypes.any,
    filterCell: PropTypes.any,
    filterTitle: PropTypes.string,
    filterable: PropTypes.bool,
    filter: PropTypes.oneOf(['text', 'numeric', 'boolean', 'date']),
    editor: PropTypes.oneOf(['text', 'numeric', 'boolean', 'date']),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    minResizableWidth: PropTypes.number,
    headerCell: PropTypes.any,
    footerCell: PropTypes.any,
    headerSelectionValue: PropTypes.bool,
    format: PropTypes.string,
    headerClassName: PropTypes.string,
    className: PropTypes.string,
    reorderable: PropTypes.bool,
    resizable: PropTypes.bool,
    orderIndex: PropTypes.number,
    groupable: PropTypes.bool,
    columnMenu: PropTypes.any,
    locked: PropTypes.bool
};
//# sourceMappingURL=GridColumn.js.map